/**
 * External dependencies
 */
import inherits from 'inherits';

export default class BarcodeLookupPlan {
    
    constructor(cscom) {
        if (!(this instanceof BarcodeLookupPlan)) {
            return new BarcodeLookupPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/barcode-lookup-plans/list', null, data);
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/barcode-lookup-plans/view', null, data);
    }    
}
